export default {"src":"/_next/static/image/public/images/sync_now.d3ea1e206e9a6e6c385cdfa01fad0582.gif","height":72,"width":72};